import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import { ParallaxProvider } from 'react-scroll-parallax'

// import AOS from 'aos'
// import 'aos/dist/aos.css'

import Header from './header'
import Footer from './footer'
import Chat from '../components/chat'
import './layout.scss'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      {
        siteTitle: site {
          siteMetadata {
            title
          }
        }
      }
    `}
    // componentDidMount={
    //   AOS.init()
    // }
    render={data => (
      <>
        <Helmet
          title={data.siteTitle.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteName="{data.siteTitle.siteMetadata.title}" />
        <div className="page-wrap">
          <Chat />
          <ParallaxProvider>{children}</ParallaxProvider>
        </div>
        <Footer />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
